module.exports = __webpack_public_path__ + "static/img/1 2014公司成立.38a03e76.jpg";